export const ENVIRONMENT = {
  url: 'https://gem-connector.com',
  api: {
    url: 'https://api.gem-connector.com'
  },
  auth0: {
    domain: 'gem-connector.eu.auth0.com',
    clientId: 'ItUM8XEoWKmwUDkCnfPZpQsaxSKT93dI', // TODO : change to OD141C613O8B9nJsTqdegLKsrnn5bSmO when old gem is unused
    authorizationParams: {
      scope: 'read:current_user'
    }
  }
};
